// Generated by ReScript, PLEASE EDIT WITH CARE


function toString(s) {
  if (s === "Light") {
    return "light";
  } else {
    return "dark";
  }
}

function fromString(s) {
  switch (s) {
    case "dark" :
        return "Dark";
    case "light" :
        return "Light";
    default:
      return "Light";
  }
}

export {
  toString ,
  fromString ,
}
/* No side effect */
